import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStoreinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M21 12L21 20C21 21.1045695 20.1045695 22 19 22L5 22C3.8954305 22 3 21.1045695 3 20L3 12M4 6L20 6"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				stroke: "#000",
				strokeWidth: 2,
				points: "14.5 15 14.5 21 9.5 21 9.5 15",
				transform: "rotate(180 12 18)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M22,9 C22,10.381 20.881,11.5 19.5,11.5 C18.119,11.5 17,10.381 17,9 C17,10.381 15.881,11.5 14.5,11.5 C13.119,11.5 12,10.381 12,9 C12,10.381 10.881,11.5 9.5,11.5 C8.119,11.5 7,10.381 7,9 C7,10.381 5.881,11.5 4.5,11.5 C3.119,11.5 2,10.381 2,9 L3.58555493,3.45055774 C3.83087011,2.59195463 4.61564211,2 5.50860283,2 L18.4913972,2 C19.3843579,2 20.1691299,2.59195463 20.4144451,3.45055774 L22,9 Z"
			})
		]
	})
});
export default SvgStoreinline;
